import React from 'react';
import styles from './InformesPage.module.css';
import stylesPanel from '../../../../styles/Panel.module.css';
import { useNavigate } from 'react-router-dom';
import HeaderTituloComponent from '../../../../components/header-titulo/HeaderTituloComponent';
import BotonCardComponent from '../../../../components/boton-card/BotonCardComponent';

const InformesPage = () => {
    const navigate = useNavigate();

    const abrirPage = (ruta) => {
        navigate(ruta);
    };

    return (
        <div className={stylesPanel.containerPrincipal}>
            <HeaderTituloComponent pagina={HeaderTituloComponent.PAGINA_INFORMES}></HeaderTituloComponent>
            <div className={stylesPanel.containerPanel}>
                <div className={styles.menuContainer}>
                    <div className={styles.menuIntro}>
                        <h2 className={styles.menuTitle}>¿Qué informe necesitas revisar?</h2>
                        <p className={styles.menuSubtitle}>
                            Revisa un resumen ejecutivo con cifras agregadas o profundiza en los reportes por encuesta según tus
                            necesidades.
                        </p>
                    </div>
                    <div className={styles.menuGrid}>
                        <BotonCardComponent
                            opcion={BotonCardComponent.MENU_INFORMES_RESUMEN}
                            customRoute="resumen"
                            onClick={abrirPage}
                        />
                        <BotonCardComponent
                            opcion={BotonCardComponent.MENU_INFORMES_ENCUESTAS}
                            customRoute="informes-encuesta"
                            onClick={abrirPage}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InformesPage;
